<span class="close" (click)="dismiss.emit()"> <mat-icon>close</mat-icon><span l10nTranslate>shared.sClose</span> </span>
<div class="header">
  <div class="title check" *ngIf="!customTitle && isSuccess" l10nTranslate>
    <mat-icon>done</mat-icon> shared.success
  </div>
  <div class="title" *ngIf="!customTitle && !isSuccess" l10nTranslate><mat-icon>close</mat-icon> shared.failure</div>
  <div class="title" *ngIf="!!customTitle">
    <mat-icon>{{ customTitle.icon }}</mat-icon> {{ customTitle.description }}
  </div>
  <div class="message" *ngIf="!!message">
    {{ message }}
  </div>
</div>

<div *ngIf="!!actions">
  <span (click)="runAction(action.routeAction)" class="actions" *ngFor="let action of actions">
    <mat-icon>{{ !action.icon ? 'arrow_back' : action.icon }}</mat-icon>
    {{ action.description }}
  </span>
</div>
